/*
 * controllers/initController.js
 * Splash Controller
 */

define( 'app/controllers/initController',[
    'app/ControllerClass',
    'app/models/systemModel',
    'app/views/splashView', 'moment', 'underscore'], function( ControllerClass, SystemModel, SplashView, moment, _ ){
    return window.app.controllers.initController = $.extend({}, ControllerClass, {
            app: app,
        module: 'init',

        loadServiceTypes: function ( roomsHref, spaHref, daysHref, skiHref ) {
            var serviceTypes = [];
        app.customization.features.pmsBooking && (roomsHref !== false ) && serviceTypes.push( {
            id : "roomsBooking",
            href : roomsHref || "roomsBooking",
            icon : "home",
            name : (!!app.customization.roomsBooking.dayGuestPromoCode&&!daysHref) ? app.localization.general.features.pmsOrDayName : app.localization.general.features.pmsName
        });
        !!app.customization.roomsBooking.dayGuestPromoCode && daysHref && serviceTypes.push( {
            id : "roomsBooking",
            href : daysHref || "roomsBooking",
            icon : "bell",
            name : app.localization.general.features.pmsDayName
        });
        app.customization.features.spaBooking && (spaHref !== false) && serviceTypes.push( {
            id : "spaBooking",
            href : spaHref || "spaBooking",
            icon : "leaf",
            name : app.localization.general.features.spaName
        });
        app.customization.features.golfBooking && serviceTypes.push( {
            id : "golfBooking",
            href : "golfBooking",
            icon : "flag",
            name : app.localization.general.features.golfName
        });
        app.customization.features.diningBooking && serviceTypes.push( {
            id : "dining",
            href : "dining",
            icon : "edit",
            name : app.localization.general.features.diningName
        });
        app.customization.features.skiBooking && (skiHref !== false) && serviceTypes.push( {
            id : "ski",
            href : skiHref || "ski",
            icon : "tag",
            name : app.localization.general.features.skiName
        });
        app.customization.features.giftCertificates && serviceTypes.push( {
            id : "giftCertificates",
            href : "giftCertificates",
            icon : "gift",
            name : app.localization.general.features.giftCertificatesName
        });
        app.customization.features.membership && serviceTypes.push( {
            id : "membership",
            href : "membership",
            icon : "certificate",
            name : app.localization.general.features.clubName
        });
        app.data.serviceTypes=serviceTypes;

    },

        // required by the dispatcher: actions, init, performAction
            actions: {
                // no routable actions in this controller
            },
            init: function() {
                console.log('initializing init controller');
                var self=this;

                if(!this.InitializedDfd) {
                    this.InitializedDfd = $.Deferred();
                    this.InitializedPromise = this.InitializedDfd.promise();
                }
                this.initCount = this.initCount ? this.initCount++ : 1;
                this.loadServiceTypes();
                console.log('wrote service types');

                app.data.languageNames=[];
                app.data.languageMap={};
                app.languageMap={};
                for( langid in app.customization.availableLanguages ){
                      if( app.customization.availableLanguages.hasOwnProperty(langid)) {
                          console.log('adding language',app.customization.availableLanguages[langid]);
                          app.data.languageNames.push( { id: app.customization.availableLanguages[langid], name: app.customization.multiLanguageLabel[app.customization.availableLanguages[langid]] } );
                          app.languageMap[app.customization.availableLanguages[langid]] = app.customization.submitLanguage[app.customization.availableLanguages[langid]];
                      }
                }
                $('html').attr('lang',app.language);
                var languageStandardName = app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.language,{});
                app.models.systemModel.dataModel.language.data = app.models.systemModel.dataModel.language.data || {};
                app.models.systemModel.dataModel.language.data[languageStandardName] = app.models.systemModel.dataModel.language.data[languageStandardName] || {};
                app.models.systemModel.dataModel.language.data[languageStandardName]['Result'] = app.languageMap[app.language];
                app.models.systemModel.dataModel.language.selectedValue = app.languageMap[app.language];
                app.data.languageMap = app.languageMap;


                app.data.breadCrumbs = {};
                app.data.messages = app.data.messages || [];
                app.data.bookingHistoryCollapseHidden = app.customization.hideInitialGuestItineraryOnBookingSummary;

                app.customization.forceSessionId && (app.data.SessionId = app.customization.forceSessionId);

                $('#loadMessage').html(app.localization.general.contactingServer);
                setActiveUserTimeOnEvents()
                
                app.models.systemModel.fetchSystemState()
                    .done(function(r_fss){         
                        if ( !app.customization.features.giftCertificates
                            && !app.customization.features.pmsBooking
                            && !app.customization.features.spaBooking
                            && !app.customization.features.golfBooking
                            && !app.customization.features.skiBooking
                            && !app.customization.features.membership
                            && !app.customization.features.diningBooking) {
                            finishInit();
                            return;
                        }
                        var defer = self.initGuestItinerary();
                        if(app.data.SessionId && (!!r_fss.WebFolioStatus && r_fss.WebFolioStatus == "ACTIVE") && +r_fss.WebFolioRemainingTimeoutMinutes > 0) {
                            $.when( defer )
                                .done(function(){
                                    app.models.systemModel.dataModel.createSession.data = app.models.systemModel.dataModel.createSession.data || {};
                                    app.models.systemModel.dataModel.createSession.data['WebFolioId/'] = app.models.systemModel.dataModel.createSession.data['WebFolioId/'] || {};
                                    app.models.systemModel.dataModel.createSession.data['WebFolioId/']['WebFolioId'] = app.data.WebFolioId;
                                    app.models.systemModel.dataModel.createSession.data['WebFolioId/']['SessionId'] = app.data.SessionId;
                                    app.models.systemModel.dataModel.createSession.data['WebFolioId/']['DefaultCustomerId'] = app.data.DefaultCustomerId;
                                    var prevFolioBalanceStandardName = app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{});
                                    app.models.systemModel.setSelected('createSession',{},app.data.WebFolioId);
                                    var newFolioBalanceStandardName = app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{});
                                    if (prevFolioBalanceStandardName!=newFolioBalanceStandardName) {
                                        app.models.systemModel.dataModel.folioBalance.data[newFolioBalanceStandardName] = app.models.systemModel.dataModel.folioBalance.data[prevFolioBalanceStandardName]
                                    }
                                    $.when(
                                        app.data.CustomerId && app.data.userLoggedIn
                                            && app.data.CustomerId!=r_fss.WebFolioCustomerId
                                            && app.models.systemModel.getData('updateSession', {CustomerId:app.data.CustomerId,CustomerGUID:app.data.CustomerGUID})
                                    ).fail(function(){
                                        console.log('updateSession failed. logging out user.')
                                        if (self.initCount>1) {
                                            window.location.reload(false);
                                        } else {
                                            app.dispatcher.redirect('profile','logout',['silent']);
                                        }
                                    }).done(function(r_us){
                                        if (r_us && r_us.ConflictingSpaBookingRemoved == 'Y') {
                                            document.location.hash = "#/summary/";
                                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                                                title:Localization.general.conflictingSpaBookingRemovedTitle,
                                                message:Localization.general.conflictingSpaBookingRemoved
                                            });
                                        }
                                        console.log('continuing previously active session');
                                        if(app.customization.dynamicRestrictions){
                                            // Adding memberVipHelper Func before evalCriteria runs if dynamicRestrictions set
                                            $.when(app.commonViewHelper.memberVipLevelsHelper()).done(function(){
                                                // Call evalCriteria if dynamic restrictions set
                                                app.commonViewHelper.evalCriteria();
                                                app.commonViewHelper.enableModuleHelper();
                                                finishInit();
                                            })
                                        } else {
                                            finishInit();
                                        }
                                    })
                                })
                                .fail(function(){
                                    $('#loadMessage').html(app.localization.general.err.restartSession);
                                })
                        } else {
                            $.when(
                                app.models.systemModel.getData('createSession', {}),
                                defer
                            )
                                .done(function(r_cs){
                                    $.cookie('sessionid', r_cs.SessionId, {expires:Date.now().add(+r_fss.WebFolioRemainingTimeoutMinutes || +app.customization.defaultSessionTimeout).minutes()});
                                    app.data.SessionId = r_cs.SessionId;
                                    app.customization.forceSessionId && (app.data.SessionId = app.customization.forceSessionId);
                                    app.datac('WebFolioId', r_cs.WebFolioId);
                                    app.datac('DefaultCustomerId', r_cs.DefaultCustomerId);
                                    var prevFolioBalanceStandardName = app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{});
                                    app.models.systemModel.setSelected('createSession',{},r_cs.WebFolioId)
                                    var newFolioBalanceStandardName = app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{});
                                    if (prevFolioBalanceStandardName!=newFolioBalanceStandardName) {
                                        app.models.systemModel.dataModel.folioBalance.data[newFolioBalanceStandardName] = app.models.systemModel.dataModel.folioBalance.data[prevFolioBalanceStandardName]
                                    }
                                    
                                    $.when(
                                        app.data.CustomerId && app.data.userLoggedIn
                                            && app.models.systemModel.getData('updateSession', {CustomerId:app.data.CustomerId,CustomerGUID:app.data.CustomerGUID})
                                        ).fail(function(){
                                            console.log('updateSession failed. logging out user.')
                                            if (self.initCount>1) {
                                                window.location.reload(false);
                                            } else {
                                                app.dispatcher.redirect('profile','logout',['silent']);
                                            }
                                        }).done(function(){
                                            console.log('clean starting new session');
                                            if(app.customization.dynamicRestrictions){
                                                // Adding memberVipHelper Func before evalCriteria runs if dynamicRestrictions set
                                                $.when(app.commonViewHelper.memberVipLevelsHelper()).done(function(){
                                                    // Call evalCriteria if dynamic restrictions set
                                                    app.commonViewHelper.evalCriteria();
                                                    app.commonViewHelper.enableModuleHelper();
                                                    finishInit();
                                                })
                                            } else {
                                                finishInit();
                                            }
                                        })

                                })
                                .fail( function( r_cs ) {
                                    $('#loadMessage').html(app.localization.general.err.startSession);
                                    //alert('We were unable to initialize the application. (csfail)');
                                });
                        }
                    })
                    .fail(function(r_mss){
                        //alert('system is offline');
                        if(app.data.WebFolioId) {
                            app.data.WebFolioId = undefined;
                            self.init();
                        } else {
                            $('#loadMessage').html(app.localization.general.err.serverOffline);
                            app.views.splashView.event.fire('displaySystemOffline');
                        }
                    });

                function finishInit(){
                    app.views.splashView.event.fire('initTemplate');
                    app.data.active = true;
                    app.data.inittime = Date.now();
                    console.log('resolving splash controller init', app.data);
                    app.controllers.initController.InitializedDfd.resolve();
                    // Tell the view to show the service selection screen
                    app.models.systemModel.monitorSystemState()
                        .progress(function(r_mss){
                            if (!!r_mss.RemainingUpTime) {
                                app.data['remainingUpTime'] = r_mss.RemainingUpTime;
                                app.views.splashView.event.fire('displayRemainingUpTime', [r_mss.RemainingUpTime]);
                            } else {
                                app.data['remainingUpTime'] = null;
                                app.views.splashView.event.fire('clearRemainingUpTime');
                            }
                            if (!!r_mss.WebFolioStatus && (r_mss.WebFolioStatus == "CHKOUT" || r_mss.WebFolioStatus == "CHKOUTC")) {
                                $.cookie('sessionid', null);
                                app.views.splashView.event.fire('folioCheckedOut');
                                app.data.active = false;
                            } else if (!!app.data.SessionId && r_mss.WebFolioStatus != "ACTIVE") {
                                $.cookie('sessionid', null);
                                app.views.splashView.event.fire('folioTimedOut');
                                app.data.active = false;
                            }
                            if (!!app.data.SessionId && r_mss.WebFolioRemainingTimeoutMinutes != undefined) {
                                $.cookie('sessionid', app.data.SessionId, {expires: Date.now().add(+r_mss.WebFolioRemainingTimeoutMinutes).minutes()});
                                app.data['folioTimeout'] = r_mss.WebFolioRemainingTimeoutMinutes;
                                if (r_mss.WebFolioRemainingTimeoutMinutes == "0") {
                                    $.cookie('sessionid', null);
                                    app.views.splashView.event.fire('folioTimedOut');
                                    app.data.active = false;
                                } else if (+r_mss.WebFolioRemainingTimeoutMinutes <= app.customization.warnFolioTimeoutMinutes) {
                                    app.views.splashView.event.fire('folioTimeoutWarning',[r_mss.WebFolioRemainingTimeoutMinutes])     
                                } else {
                                    app.views.splashView.event.fire('clearTimeoutWarning');
                                }
                            }
                        })
                        .fail(function(r_mss){
                            app.data.active = false;
                            app.views.splashView.event.fire('displaySystemOffline');
                        });
                    $(window).trigger( 'hashchange', app );
                }
                function setActiveUserTimeOnEvents(){
                    $(document).on("mousemove keypress scroll tap taphold swipe", function(){
                     app.data['lastUserActiveTime'] = moment().toDate()
                    });
                }

                //adds hooks to all events in all the views - the following shares references to all the views - rooms, spa, golf, etc
                _.each(app.views.splashView.event.events.data('events'), function(viewEvent){
                    var viewEventHandler = viewEvent[0].handler;
                        viewEvent[0].handler = function(){
                            if(viewEvent[0].syncTriggerBefore){
                                viewEvent[0].syncTriggerBefore.apply(this, arguments);
                            }
                            viewEventHandler.apply(this, arguments);
                            if(viewEvent[0].syncTriggerAfter){
                                viewEvent[0].syncTriggerAfter.apply(this, arguments);
                            }
                        }
                })
            },

            initGuestItinerary: function (reinitModules) {
                var defer = $.Deferred(),
                    deferreds = [],
                    itinerarySources = []
                app.customization.features.pmsBooking && itinerarySources.push({name:'pmsBooking', model:'fetchCustomerPMSBookings', data:'PMSBooking', date:'DepartureDate',reserved:['RESERV'], completed:'CHKOUT', folioid:'PMSFolioId'});
                app.customization.features.spaBooking && itinerarySources.push({name:'spaBooking', model:'fetchCustomerSpaBookings', data:'SpaFolio', subitem:'SpaFolioItem', date:'BookStartTime', reserved:['BKD'], completed:'COM', folioid:'SpaFolioId'});
                app.customization.features.diningBooking && itinerarySources.push({name:'diningBooking', model:'fetchCustomerDiningReservations', data:'DiningReservation', date:'DateTime', reserved:['Confirmed', "Booked"], completed:'Closed', waitListed: ["WaitListQueued", 'Wait'], folioid:'BookingId'});
                // {name:'skiBooking', model:'fetchCustomerSkiBookings', data:'SkiFolio', subitem:'SkiFolioItem', date:'BookStartTime', reserved:'BKD', completed:'COM', folioid:'SkiFolioId'}
                app.customization.features.golfBooking && itinerarySources.push({name:'golfBooking', model:'fetchCustomerGolfBookings', data:'GolfBooking', date:'BookingTime', folioid:'GolfBookingId', aggregateGolfPlayers:'GolfPlayer'});

                if([].concat(reinitModules || []).length > 0) {
                    itinerarySources = itinerarySources.filter(function(source){ return reinitModules.indexOf(source.model) > -1 });
                }

                $.each(itinerarySources, function(i,itinerarySource){
                    var semaphore = $.Deferred();
                    deferreds.push(semaphore.promise());
                    app.data[itinerarySource.name+'Future'] = [];
                    app.data[itinerarySource.name+'Past'] = [];
                    app.data[itinerarySource.name+'s'] = [];
                    if (app.data.CustomerId && app.data.CustomerGUID && app.customization.features[itinerarySource.name]) {
                        $.when(
                            app.models.userModel.getData(itinerarySource.model, {CustomerId:app.data.CustomerId,CustomerGUID:app.data.CustomerGUID}),
                            app.customization.features.pmsBooking && (deferreds.length>1) && deferreds[0]
                        )
                            .done(function(r,r2){
                                if (itinerarySource.name == "pmsBooking") {
                                        app.data.datesForRestrictedFolio = false;
                                }
                                // This ternary operator fix for cases no bookings return from backend
                                var sortedBookings = r[itinerarySource.data] != undefined ? _.sortBy([].concat(r[itinerarySource.data]) || [], itinerarySource.date) : [];

                                $.each(sortedBookings, function(i,theBookingItem){
                                    var bookingItemArray = [].concat(itinerarySource.subitem ? theBookingItem[itinerarySource.subitem] : theBookingItem),
                                        theDate=null;

                                    app.data.restrictedFolioStartDate = new Date('2000-01-01')
                                    app.data.restrictedFolioEndDate = new Date('2000-01-01')
                                    $.each(bookingItemArray, function(j,bookingItem){
                                        if (!bookingItem || ((!!itinerarySource.reserved||!!itinerarySource.completed || !!itinerarySource.waitListed) && ([].concat(itinerarySource.reserved, itinerarySource.completed, itinerarySource.waitListed).indexOf(bookingItem.BookStatus) === -1)) || !bookingItem[itinerarySource.date] || ((theDate = Date.parseExact(bookingItem[itinerarySource.date].substr(0,10).concat('235959'),"yyyy-MM-ddHHmmss")) === null)) {
                                            return;
                                        }
                                        if (moment(bookingItem[itinerarySource.date], 'YYYY-MM-DD').endOf('d') >= moment()) {
                                            if ([].concat(itinerarySource.reserved, itinerarySource.waitListed).indexOf(bookingItem.BookStatus) > -1){
                                                app.data[itinerarySource.name+'Future'] = app.data[itinerarySource.name+'Future'] || [];
                                                app.data[itinerarySource.name+'Future'].push(theBookingItem[itinerarySource.folioid]);
                                                theBookingItem.Future = true;
                                            } else {
                                                return;
                                            }
                                        } else if(Date.parseExact(bookingItem[itinerarySource.date].substr(0,10),"yyyy-MM-dd") < Date.now()) {
                                            if (itinerarySource.name === "diningBooking" || bookingItem.BookStatus == itinerarySource.completed){
                                                app.data[itinerarySource.name+'Past'] = app.data[itinerarySource.name+'Past'] || [];
                                                app.data[itinerarySource.name+'Past'].push(theBookingItem[itinerarySource.folioid]);
                                                theBookingItem.Past = true;
                                            } else {
                                                return;
                                            }
                                        }
                                        bookingItem.date = theDate;
                                        if (theBookingItem.DailyRateDetails) {
                                            var dailyRateDetails = $.firstOrOnly(theBookingItem.DailyRateDetails);
                                            theBookingItem.PMSRateType = dailyRateDetails.PMSRateType;
                                            theBookingItem.PMSRateId = dailyRateDetails.PMSRateId;
                                        }
                                        if (_.any(app.data.pmsDayBookings,function(x){return x==theBookingItem.PMSFolioId})) {
                                            theBookingItem.isDayBooking = true;
                                        }
                                        if (!app.data[itinerarySource.name+'s']) {
                                            app.data[itinerarySource.name+'s'] = []
                                        }
                                        if (itinerarySource.subitem) {
                                            var slicedBookingItem = $.extend( {}, theBookingItem );
                                            slicedBookingItem[itinerarySource.subitem] = $.extend( {}, bookingItem );
                                            app.data[itinerarySource.name+'s'].push( slicedBookingItem );
                                        } else {
                                            app.data[itinerarySource.name+'s'].push( theBookingItem );
                                        }
                                        if (itinerarySource.name == "pmsBooking" && app.data.RestrictedFolio && theBookingItem[itinerarySource.folioid] == app.data.RestrictedFolio) {
                                            app.data.datesForRestrictedFolio = [];
                                            app.data.restrictedFolioStartDate = Date.parseExact(theBookingItem.ArrivalDate, "yyyy-MM-ddHHmmss");
                                            app.data.restrictedFolioEndDate = Date.parseExact(theBookingItem.DepartureDate, "yyyy-MM-ddHHmmss");
                                            for (var theDate = app.data.restrictedFolioStartDate.clone(); theDate <= app.data.restrictedFolioEndDate; theDate.add(1).day()) {
                                                app.data.datesForRestrictedFolio.push({
                                                    human:theDate.toString(app.localization.CultureInfo.formatPatterns.longDate),
                                                    machine:theDate.toString("yyyy-MM-dd")
                                                });
                                            }
//                                         } else {
//                                             app.data.datesForRestrictedFolio = false;
                                        }
                                    });
                                    if (app.data.RestrictedFolio) {
                                        app.data[itinerarySource.name + 'Past'] = []
                                        if (itinerarySource.name == "pmsBooking") {
                                            // app.data[itinerarySource.name + 'Future'] = _.filter(app.data[itinerarySource.name + 'Future'], function (bookingItem) {
                                            //     return bookingItem[itinerarySource.folioid] == app.data.RestrictedFolio
                                            // })
                                        } else {
                                            app.data[itinerarySource.name + 'Future'] = _.filter(app.data[itinerarySource.name + 'Future'], function (bookingItemId) {
                                                var bookingItem = _.find(app.data[itinerarySource.name+'s'],function(x){return x[itinerarySource.folioid]==bookingItemId});
                                                bookingItem = (bookingItem && bookingItem[itinerarySource.subitem]) ? bookingItem[itinerarySource.subitem] : bookingItem;
                                                return bookingItem && bookingItem[itinerarySource.date].substr(0, 10) >= app.data.restrictedFolioStartDate.toString("yyyy-MM-dd") &&
                                                    bookingItem[itinerarySource.date].substr(0, 10) <= app.data.restrictedFolioEndDate.toString("yyyy-MM-dd")
                                            })
                                        }
                                    }
                                  if (itinerarySource.name == 'golfBooking' && itinerarySource.aggregateGolfPlayers && theBookingItem[itinerarySource.aggregateGolfPlayers]) {
                                    theBookingItem.golfPlayers = _.reduce(
                                                        _.isArray(theBookingItem[itinerarySource.aggregateGolfPlayers])
                                                          ? theBookingItem[itinerarySource.aggregateGolfPlayers]
                                                          : [theBookingItem[itinerarySource.aggregateGolfPlayers]]
                                                      , function( aggregate, player ) {
                                                          if (player.BookStatus!='CNL' && player.BookStatus!='NSH') {
                                                            aggregate.players += 1
                                                            aggregate.price += +player.ItemPrice
                                                            aggregate.itemName = player.ItemName
                                                            aggregate.courseId = player.CourseId
                                                          }
                                                        return aggregate
                                                        }
                                                      , { players: 0, price: 0 }
                                                    )
                                  }
                                })
                                console.log('done semaphore',semaphore);
                                semaphore.resolve();
                            })
                            .fail(function(r){
                                app.data[itinerarySource.name+'s'] = [];
                                app.data[itinerarySource.name+'s'].noData = true;
                                console.log('fail semaphore',semaphore);
                                semaphore.resolve();
                            });
                    } else {
                        app.data[itinerarySource.name+'s'] = [];
                        semaphore.resolve();
                    }
                  

                })
                 //check if there still a golf booking in cart
                if(!app.data.userLoggedIn) app.datal("clubBookingInCart",false)
                $.when.apply(this,deferreds).done(function(){
                    console.log('resolving itinerarySources');
                    if (app.data.clubBookingInCart) {
                        setTimeout(function () {
                            $.when(
                                    (!app.models.systemModel.dataModel.folioBookings.data ?
                                        app.models.systemModel.getData('folioBookings', {}) :
                                        app.models.systemModel.dataModel.folioBookings.data[
                                            app.models.roomsModel.makeStandardName(app.models.systemModel.dataModel.folioBookings, {})
                                        ]
                                    )
                                )
                                .always(function (r_fb) {
                                    if (r_fb) {
                                        if (!r_fb.WebFolioItem || _.isEmpty(r_fb.WebFolioItem)) app.datal("clubBookingInCart", false)
                                        _.each(r_fb.WebFolioItem, function (booking) {
                                            if (booking.Category != 'Club') { //if ithere is a club, then no other booking of different category will be there
                                                app.datal("clubBookingInCart", false)
                                            }
                                        })
                                    }
                                })
                        }, 300)
                    }
                    defer.resolve(deferreds.length);
                    if(app.customization.features.pmsBooking && app.data.pmsBookings){
                        setTimeout(function(){
                            eregPopupHandler(app.data.pmsBookings);
                        },3000);
                    };
                }).fail(function(){
                    console.log('itinerarySources failed');
                    defer.reject()
                });
                return defer.promise();

                function eregPopupHandler (pmsBookings){
                    var dismissedFolioIds = app.datal('dismissedEregFolioIds') != undefined ? app.datal('dismissedEregFolioIds') : [];
                    var intendedPmsFolioId = '';
                    // Check if user logged in with pms folioid if they are redirect them to that ereg form
                    if(app.data.RestrictedLogin && app.data.RestrictedFolio && app.data.RestrictedFolio.length){
                        intendedPmsFolioId = app.data.RestrictedFolio;
                        dismissedFolioIds = dismissedFolioIds.filter(function(pmsFolioId){ return pmsFolioId != intendedPmsFolioId});
                    }
                    var filteredPmsBookings = pmsBookings.filter(function(booking){
                        // Arrival Date should be same or later than today
                        var checkDateValid =  Date.parseExact(booking.ArrivalDate.substr(0,10),"yyyy-MM-dd") >= Date.now();
                        return booking.BookStatus == 'RESERV' && booking.HasSignature == 'N' && booking.PreCheckInStatus == 'A' && checkDateValid && !dismissedFolioIds.includes(booking.PMSFolioId);
                    })
                    // Booking Summary or checkout pages won't show modal
                    var checkPage = window.location.href.indexOf('summary') == -1;
                    if(filteredPmsBookings.length == 1 && checkPage){
                        $('#eregpopup .eregHeader').html(app.localization.eReg.popupHeader);
                        $('#eregpopup .eregpopupWrap').prepend('<button data-dismiss="modal">Cancel</button>');
                        $('#eregpopup .eregpopupWrap').prepend('<button><a class="eregFill">'+app.localization.eReg.popupButtonButton+'</a></button>');
                        $('#eregpopup .eregpopupWrap .eregFill').attr('href','#/summary/eReg/'+filteredPmsBookings[0].Venue+'/'+filteredPmsBookings[0].PMSFolioId+'/'+app.data.LastName);

                        $('#eregpopup').modal({
                            backdrop:false,
                            show:true,
                            keyboard:true
                        });               
                    } else if(filteredPmsBookings.length > 1 && checkPage){
                        var foundIntendedPms = filteredPmsBookings.find(function(pmsFolio){ return pmsFolio.PMSFolioId == intendedPmsFolioId});

                        if(foundIntendedPms){
                            $('#eregpopup .eregHeader').html(app.localization.eReg.popupHeader);
                            $('#eregpopup .eregpopupWrap').prepend('<button data-dismiss="modal">Cancel</button>');
                            $('#eregpopup .eregpopupWrap').prepend('<button><a class="eregFill">'+app.localization.eReg.popupButtonButton+'</a></button>');
                            $('#eregpopup .eregpopupWrap .eregFill').attr('href','#/summary/eReg/'+foundIntendedPms.Venue+'/'+foundIntendedPms.PMSFolioId+'/'+app.data.LastName);
                        } else {
                            $('#eregpopup .eregHeader').html(app.localization.eReg.popupHeaderMulti);
                            $('#eregpopup .eregHeader span').text(' for '+filteredPmsBookings.length + ' reservations');
                            $('#eregpopup .eregpopupWrap').prepend('<button data-dismiss="modal">Cancel</button>');
                            $('#eregpopup .eregpopupWrap').prepend('<button><a href="#/summary">'+app.localization.eReg.popupButtonMulti+'</a></button>');
                        }

                        $('#eregpopup').modal({
                            backdrop:false,
                            show:true,
                            keyboard:true
                        });
                    }  
                    
                    $('#eregpopup button[data-dismiss]').click(function(){
                        var newDismissedFolioIds = app.datal('dismissedEregFolioIds') != undefined ? app.datal('dismissedEregFolioIds') : [];
                        filteredPmsBookings.forEach(function(item){
                            newDismissedFolioIds.push(item.PMSFolioId);
                        })
                        app.datal('dismissedEregFolioIds', newDismissedFolioIds);
                    })                
                }
            }, 

        })
});

